import React from 'react';
import DepartmentsPageHeader from './DepartmentsPageHeader';
import DepartmentsPageSession from './DepartmentsPageSession';

function DepartmentsPage() {
  return (
    <div className="page-wrapper">
      <DepartmentsPageHeader />
      <DepartmentsPageSession />
    </div>
  );
}

export default DepartmentsPage;
